import React from 'react';
import SEO from '../components/common/SEO';
import GlobalPresence from '../components/common/GlobalPresence';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import './About.css';

const About: React.FC = () => {
  return (
    <>
      <SEO 
        title="About Us"
        description="Learn about Skytion Enterprises, established 2022 in Noida. Premium tissue manufacturing from virgin & recycled pulp with 80% women workforce serving India, USA, Indonesia."
        keywords="skytion enterprises, tissue manufacturing, noida, 2022, women workforce, virgin pulp, recycled pulp, skysun brand, manufacturing facility, quality assurance"
        schemaType="AboutPage"
        canonical="https://skytion.in/about"
      />
      
      {/* Hero Section with Company Photo */}
      <section 
        className="py-5" 
        style={{
          backgroundImage: 'url(/assets/skytion/backgrounds/colourfull kitchen towel wallpaper.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundColor: 'rgba(255, 255, 255, 0.9)',
          backgroundBlendMode: 'overlay'
        }}
      >
        <Container>
          <Row className="align-items-center py-5">
            <Col md={6}>
              <img 
                src="/assets/skytion/brand/skytion logo png.png" 
                alt="Skytion Enterprises Logo"
                className="mb-4"
                style={{maxWidth: '250px'}}
              />
              <h1 className="display-4 mb-4">About Skytion Enterprises</h1>
              <p className="lead mb-4">
                Established in 2022, Skytion Enterprises is a premium tissue manufacturing company based in Noida. 
                We specialize in producing high-quality tissue products from virgin and recycled pulp under our Skysun brand.
              </p>
              <div className="company-stats d-flex gap-4">
                <div>
                  <h3 className="text-primary mb-0">2022</h3>
                  <small>Established</small>
                </div>
                <div>
                  <h3 className="text-success mb-0">80%</h3>
                  <small>Women Workforce</small>
                </div>
                <div>
                  <h3 className="text-info mb-0">9+</h3>
                  <small>Product Lines</small>
                </div>
              </div>
            </Col>
            <Col md={6}>
              <img 
                src="/assets/skytion/company/Facility photo.png" 
                alt="Skytion Manufacturing Facility"
                className="img-fluid rounded shadow"
              />
            </Col>
          </Row>
        </Container>
      </section>

      {/* Global Presence Banner */}
      <GlobalPresence />

      {/* Our Story - Using Brand Assets */}
      <section className="py-5">
        <Container>
          <div className="text-center mb-5">
            <h2 className="display-5 mb-3">Our Manufacturing Story</h2>
            <p className="lead">From vision to reality - building India's premium tissue manufacturing company</p>
          </div>
          <Row className="g-4">
            <Col md={6}>
              <Card className="h-100">
                <Card.Img 
                  variant="top"
                  src="/assets/skytion/products/kitchen-towel-png.png" 
                  alt="Premium Kitchen Towel - Skytion Quality"
                  style={{height: '250px', objectFit: 'cover'}}
                />
                <Card.Body>
                  <Card.Title>Premium Product Range</Card.Title>
                  <Card.Text>
                    Our Skysun brand encompasses 9 premium tissue products including 2-ply dining tissues, 
                    toilet rolls, kitchen towels, M-fold and C-fold tissues for commercial use.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col md={6}>
              <Card className="h-100">
                <Card.Img 
                  variant="top"
                  src="/assets/skytion/brand/toilet & tissue papaer branding.jpg" 
                  alt="Toilet and Tissue Paper Branding"
                  style={{height: '250px', objectFit: 'cover'}}
                />
                <Card.Body>
                  <Card.Title>Quality Manufacturing</Card.Title>
                  <Card.Text>
                    Located in Ecotech Phase 3, Gautam Buddha Nagar, Noida, our modern facility 
                    operates with advanced machinery and rigorous quality control processes.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Manufacturing Process - Using Company Assets */}
      <section className="py-5" style={{backgroundColor: '#f8f9fa'}}>
        <Container>
          <div className="text-center mb-5">
            <h2 className="display-5 mb-3">Manufacturing Excellence</h2>
            <p className="lead">State-of-the-art processes from raw materials to finished products</p>
          </div>
          <Row className="g-4">
            <Col md={4}>
              <div className="text-center">
                <img 
                  src="/assets/skytion/company/paper-napkin-manufacturing.jpg" 
                  alt="Paper Napkin Manufacturing Process"
                  className="img-fluid rounded shadow mb-3"
                  style={{height: '200px', objectFit: 'cover', width: '100%'}}
                />
                <h5>Raw Material Processing</h5>
                <p>Virgin and recycled pulp processing with advanced machinery for consistent quality</p>
              </div>
            </Col>
            <Col md={4}>
              <div className="text-center">
                <img 
                  src="/assets/skytion/company/new_lines_and_rebuilds.webp" 
                  alt="New Production Lines"
                  className="img-fluid rounded shadow mb-3"
                  style={{height: '200px', objectFit: 'cover', width: '100%'}}
                />
                <h5>Production Lines</h5>
                <p>Modern production lines capable of handling diverse product specifications and bulk orders</p>
              </div>
            </Col>
            <Col md={4}>
              <div className="text-center">
                <img 
                  src="/assets/skytion/company/manucturing image.jpeg" 
                  alt="Manufacturing Quality Control"
                  className="img-fluid rounded shadow mb-3"
                  style={{height: '200px', objectFit: 'cover', width: '100%'}}
                />
                <h5>Quality Assurance</h5>
                <p>Comprehensive quality control ensuring each product meets our premium standards</p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Product Quality Features */}
      <section className="py-5">
        <Container>
          <div className="text-center mb-5">
            <h2 className="display-5 mb-3">Product Quality Standards</h2>
            <p className="lead">Three pillars of our tissue product excellence</p>
          </div>
          <Row className="text-center">
            <Col md={4} className="mb-4">
              <img 
                src="/assets/skytion/icons/Softness Icon.png" 
                alt="Softness Quality"
                style={{width: '100px', height: '100px'}}
                className="mb-3"
              />
              <h4>Premium Softness</h4>
              <p>Ultra-soft texture achieved through careful material selection and processing techniques</p>
            </Col>
            <Col md={4} className="mb-4">
              <img 
                src="/assets/skytion/icons/Durability Icon.png" 
                alt="Durability Quality"
                style={{width: '100px', height: '100px'}}
                className="mb-3"
              />
              <h4>Superior Durability</h4>
              <p>Strong and tear-resistant products that maintain integrity during use</p>
            </Col>
            <Col md={4} className="mb-4">
              <img 
                src="/assets/skytion/icons/Absorbency Icon.png" 
                alt="Absorbency Quality"
                style={{width: '100px', height: '100px'}}
                className="mb-3"
              />
              <h4>High Absorbency</h4>
              <p>Excellent absorption capacity for effective cleaning and hygiene applications</p>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Certifications & Awards */}
      <section className="py-5" style={{backgroundColor: '#f8f9fa'}}>
        <Container>
          <div className="text-center mb-5">
            <h2 className="display-5 mb-3">Certifications & Quality Assurance</h2>
            <p className="lead">Recognized quality standards and premium manufacturing processes</p>
          </div>
          <Row className="align-items-center text-center">
            <Col md={4} className="mb-4">
              <img 
                src="/assets/skytion/brand/certification badge .png" 
                alt="Quality Certification"
                className="img-fluid"
                style={{maxWidth: '200px'}}
              />
            </Col>
            <Col md={4} className="mb-4">
              <img 
                src="/assets/skytion/brand/premium quality tag.png" 
                alt="Premium Quality Tag"
                className="img-fluid"
                style={{maxWidth: '200px'}}
              />
            </Col>
            <Col md={4} className="mb-4">
              <img 
                src="/assets/skytion/brand/GOLD_RIM-removebg-preview.png" 
                alt="Gold Quality Award"
                className="img-fluid"
                style={{maxWidth: '200px'}}
              />
            </Col>
          </Row>
        </Container>
      </section>

      {/* Contact Information */}
      <section 
        className="py-5 contact-section" 
        style={{
          backgroundImage: 'url(/assets/skytion/backgrounds/tissue paper.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundColor: 'rgba(0, 0, 0, 0.7)',
          backgroundBlendMode: 'overlay'
        }}
      >
        <Container>
          <Row className="text-center text-white">
            <Col md={12}>
              <h2 className="display-5 mb-4">Connect with Skytion Enterprises</h2>
              <div className="row justify-content-center">
                <div className="col-md-8">
                  <p className="lead mb-4">
                    Ready to partner with us for premium tissue products? Contact our team for bulk orders, 
                    custom specifications, and competitive pricing.
                  </p>
                  <div className="contact-info">
                    <p className="h5 mb-2">📞 +91 8920065965</p>
                    <p className="h5 mb-2">📧 info@skytion.in</p>
                    <p className="mb-3">Ecotech Phase 3, Gautam Buddha Nagar, Noida</p>
                  </div>
                  <Link to="/contact" className="btn btn-primary btn-lg me-3">Get In Touch</Link>
                  <Link to="/products" className="btn btn-outline-light btn-lg">View Products</Link>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default About;